module.exports = __webpack_public_path__ + "media/bootstrap-icons/input-cursor-1539baec.svg";